import React from "react";
import dayjs from "dayjs";
import styled from "styled-components";

import { getWhens, capitalize } from "../helpers/utils";

const SourceWrapper = styled.div`
  font-size: 0.8em;
  margin-top: 1.5rem;
  font-style: italic;
`;

const formatRange = (when, includeYear=false) => {
  const year = includeYear ? ", YYYY" : "";
  if (when.start === when.end) {
    return dayjs(when.start).format("MMMM D" + year);
  } else {
    return (
      dayjs(when.start).format("MMMM D" + year) +
      "—" +
      dayjs(when.end).format("MMMM D" + year)
    );
  }
};

const Source = ({ timeframe, latestDay}) => {
  const { currWhen, prevWhen, yearAgoWhen } = getWhens(timeframe, latestDay);

  return (
    <SourceWrapper>
      <b>Source: Lightcast Job Posting Analytics</b>
      <p>
        With "{timeframe}" selected, postings are displayed for{" "}
        {formatRange(currWhen)} unless otherwise indicated. "
        {capitalize(timeframe)} over {timeframe}" change refers to the change
        from {formatRange(prevWhen)} to {formatRange(currWhen)}. "Change from
        last year" refers to the change from {formatRange(yearAgoWhen, true)} to{" "}
        {formatRange(currWhen, true)}.
      </p>
      <p>
        All job posting counts reflect{" "}
        <a href="https://kb.emsidata.com/analyst/glossary/#unique-jobs-postings" target="glossary">
          unique postings
        </a>{" "}
        that were{" "}
        <a href="https://kb.emsidata.com/analyst/glossary/#active-job-postings" target="glossary">
          active
        </a>{" "}
        during the indicated time frame.
      </p>
    </SourceWrapper>
  );
};

export default Source;